import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const SaleBookingTdsApi = createApi({
  reducerPath: "OutstandingApi",
  baseQuery: authBaseQuery,
  tagTypes: ["SaleBookingTds"],
  // tagTypes: ["IncentiveRequests", "SaleBookingTds"], // ✅ Define this
  endpoints: (builder) => ({
    getAllSaleBookingCloseList: builder.query({
      query: ({ status, page = 1 }) =>
        `sales/invoice_tds_status_wise_data?status=${status}&page=${page}`,

      transformResponse: (response) => {
        return response?.data
          ? { data: response.data, pagination_data: response.pagination_data }
          : [];
      },

      providesTags: ["SaleBookingTds"],
    }),

    updateSaleBookingSingleTdsVerify: builder.mutation({
      query: ({ id, ...saleBookingTdsVerify }) => ({
        url: `sales/invoice_tds_verify/${id}`,
        method: "PUT",
        body: saleBookingTdsVerify,
      }),
      invalidatesTags: ["SaleBookingTds"],
    }),
    // /incentive_request_list_for_finance & incentive_request giving same response
    // getIncentiveRequest: builder.query({
    //   query: (status) =>
    //     `sales/incentive_request_list_for_finance`,
    //   transformResponse: (response) => response?.data || [],
    //   // keepUnusedDataFor: 0,
    // }),
    getIncentiveRequest: builder.query({
      query: (status) =>
        `sales/incentive_request`,
      transformResponse: (response) => response?.data || [],
      // keepUnusedDataFor: 0,
    }),
    getUserAllowedIncentiveData: builder.query({
      query: (userID) =>
        `sales/incentive_relesed_button_data/${userID}`,
      transformResponse: (response) => response?.data || [],
      // keepUnusedDataFor: 0,
    }),
    updateIncentiveRelease: builder.mutation({
      query: (payload) => ({
        url: `sales/incentive_request_release_by_finance/${payload.incentive_request_id}`,
        method: "PUT",
        body: payload,
      }),
      // invalidatesTags: ["IncentiveRequests"],
    }),
  }),
});

export const {
  useGetAllSaleBookingCloseListQuery,
  useUpdateSaleBookingSingleTdsVerifyMutation,
  useGetIncentiveRequestQuery,
  useGetUserAllowedIncentiveDataQuery,
  useUpdateIncentiveReleaseMutation,
} = SaleBookingTdsApi;

export default SaleBookingTdsApi;
